import urls from '@/legacy/config/env';
import { fetchRequest } from '@/legacy/services';
import { useQuery } from '@tanstack/react-query';
import { mapUserInfoFromApi } from '../../domain/mappers';
import type { UserInfo } from '../types';
import { USER_INFO_QUERY_KEY } from '../constants';
import { TWENTY_FOUR_HOURS_IN_MS } from '@/shared/constants';

export const useUserInfo = () => {
	const query = useQuery({
		queryKey: [USER_INFO_QUERY_KEY],
		queryFn: async () => {
			const response = await fetchRequest<UserInfo>({
				url: urls.auth.userInfo,
				method: 'GET',
			});
			return mapUserInfoFromApi(response.data);
		},
		staleTime: TWENTY_FOUR_HOURS_IN_MS,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
	});

	return query;
};
